import { Button, Modal } from "@telluscompany/design-system";
import { useCreateModal } from "@shared/hooks";
import { DocumentUploadFormData } from "../../schemas";
import { useLocalization } from "@i18n";
import { DocumentViewer } from "./DocumentViewer";
import { UploadDocumentModal } from "./UploadDocumentModal";
import { TermsOfUsePdf } from "../../../../../../../public/index";

const ReleaseNotesTab = () => {
  const { translate } = useLocalization();
  const { modals, openCreate, closeCreate } = useCreateModal();

  const handleUpload = (data: DocumentUploadFormData) => {
    console.log("Upload release notes:", data);
    closeCreate();
  };

  return (
    <div className="flex flex-col h-full p-4">
      <div className="flex justify-end mb-4">
        <Button variant="primary" onClick={openCreate}>
          {translate("management.releaseNotes.button.addNewVersion")}
        </Button>
      </div>

      <DocumentViewer fileUrl={TermsOfUsePdf} />

      <Modal
        open={modals.create}
        content={
          <UploadDocumentModal onSubmit={handleUpload} onCancel={closeCreate} />
        }
        onClose={closeCreate}
        title={translate("management.releaseNotes.modal.title.create")}
      />
    </div>
  );
};

export default ReleaseNotesTab;
